"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultClientOptions = exports.defaultAccountOptions = exports.OAuthTokenType = void 0;
__exportStar(require("./account/utils/AccountTypes"), exports);
__exportStar(require("./affiliate/types"), exports);
__exportStar(require("./analyticsData/utils/AnalyticsDataTypes"), exports);
__exportStar(require("./catalog/utils/CatalogUtils"), exports);
__exportStar(require("./codeRedemption/utils/CodeRedemptionTypes"), exports);
__exportStar(require("./constants/ServiceErrors"), exports);
__exportStar(require("./eula/utils/EulaUtils"), exports);
__exportStar(require("./eula/utils/EulaMarkdownUtils"), exports);
__exportStar(require("./receipt/types"), exports);
__exportStar(require("./review/utils/ReviewTypes"), exports);
__exportStar(require("./utils/ErrorUtils"), exports);
__exportStar(require("./utils/ServiceUtils"), exports);
__exportStar(require("./utils/ValidationUtils"), exports);
__exportStar(require("./utils/errors/GeneralServiceError"), exports);
__exportStar(require("./utils/errors/ValidationError"), exports);
__exportStar(require("./validations/types"), exports);
var OAuthTokenType;
(function (OAuthTokenType) {
    OAuthTokenType["eg1"] = "eg1";
})(OAuthTokenType = exports.OAuthTokenType || (exports.OAuthTokenType = {}));
exports.defaultAccountOptions = {
    includeOAuthAccountToken: true
};
exports.defaultClientOptions = {
    includeOAuthClientToken: true
};
//# sourceMappingURL=index.js.map